import Vue from 'vue'
// https://www.npmjs.com/package/vue-circle-slider
import VueCircleSlider from 'vue-circle-slider'

Vue.use(VueCircleSlider)
